import type { AlertIngestHealthResponse } from "./types";

type AlertIngestTone = "green" | "amber";

export function summarizeAlertIngestOperatorLine(
  health?: AlertIngestHealthResponse,
  options?: { failed?: boolean },
): {
  tone: AlertIngestTone;
  title: string;
  counts: string;
  review: string;
} {
  if (!health || options?.failed) {
    return {
      tone: "amber",
      title: "소스 확인",
      counts: "상태 확인 중",
      review: "최근 점검 대기",
    };
  }

  const countParts = [`정상 ${health.okCount}`];
  if (health.failingCount > 0) countParts.push(`실패 ${health.failingCount}`);
  if (health.cooldownCount > 0) countParts.push(`쿨다운 ${health.cooldownCount}`);
  if (health.disabledCount > 0) countParts.push(`비활성 ${health.disabledCount}`);

  const review =
    health.reviewSources.length > 3
      ? `${health.reviewSources.slice(0, 3).join(", ")} 외 ${health.reviewSources.length - 3}개`
      : health.reviewSources.join(", ") || "추가 점검 없음";

  return {
    tone: health.failingCount > 0 || health.cooldownCount > 0 ? "amber" : "green",
    title: health.failingCount > 0 || health.cooldownCount > 0 ? "소스 점검" : "소스 정상",
    counts: countParts.join(" · "),
    review,
  };
}
